import e from "../../node_modules/@babel/runtime/helpers/esm/extends.js";
import { __rest as t } from "../../node_modules/tslib/tslib.es6.js";
import o from "react";
var r = function r(_r) {
  var s = _r.shouldShow,
    i = _r.src,
    l = t(_r, ["shouldShow", "src"]),
    c = "//img2.storyblok.com/32x0/filters:blur(10)" + i.replace("//a.storyblok.com", "").replace("https:", "");
  return o.createElement("img", e({}, l, {
    alt: "",
    style: {
      position: "absolute",
      top: "0px",
      left: "0px",
      width: "100%",
      height: "100%",
      objectFit: "cover",
      objectPosition: "center center",
      transition: "opacity 500ms linear",
      opacity: s ? 1 : 0
    },
    "aria-hidden": !0,
    decoding: "async",
    src: c
  }));
};
export { r as Placeholder };